/**
 * Created by vsuthar on 9/22/21
 * File: Avtar
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   Avtar component will render letters in rounded circle format. We can enhance this to render images and other stuff
 *   as children.
 */
import { Bold, classNames } from '@panwds/react-ui'
import type { VFC } from 'react'
import { FF_USE_NEW_LEFT_NAV } from '../../utils/FeatureFlags'
import { getFrameworkVar } from '../../utils/Sparky'

export type AvatarProps = {
  letter: string
}
const Avatar: VFC<AvatarProps> = ({ letter }) => {
  /**
   *     ========= ALL Global Reducer ===========
   */

  /**
   *     ========= Local State ===========
   */


  /**
   *     ========= Lifecycle =============
   */


  /**
   *     ========= Callback ===========
   */
  const ff_use_new_left_nav = getFrameworkVar(FF_USE_NEW_LEFT_NAV)
  const radius = ff_use_new_left_nav ? '1.5rem' : '24px'
  const className = classNames(
    'tsg-avatar',
    'cm-rounded-full cm-border-solid cm-inline-block cm-text-center cm-text-blue-300 cm-justify-center cm-border-opacity-100 cm-border-2 cm-border-yellow-400',
    ff_use_new_left_nav && '-cm-mx-1',
  )
  const style = { height: radius, width: radius, lineHeight: ff_use_new_left_nav ? '1rem' : '20px' }
  return (<div style={style} className={className} >
    <Bold addClassName={ff_use_new_left_nav ? 'cm-text-[.75rem] cm-align-middle' : 'cm-text-[11px] cm-align-top'}>{letter}</Bold>
  </div>)
}

export default Avatar
